<template>

	<v-layout justify-center>
		<v-card class="elevation-12" max-width="700" outlined>
			<v-tabs>
				<v-tab to="/resumen">Resumen</v-tab>
				<v-tab to="/escenario">Escenario</v-tab>
				<v-tab to="/ensayos">Ensayos</v-tab>
				<v-tab to="/datos">Datos</v-tab>
			</v-tabs>

			<router-view></router-view>

		</v-card>

		<!--
		<v-btn 
		absolute
		top
		left
		class="ma-2" 
		color="primary"
		to="/pruebas" 
		dark>
			<v-icon dark left>mdi-arrow-left</v-icon>Volver
		</v-btn>
		-->

	</v-layout>

	</template>

<script>
	export default {
		created () {
			this.$store.dispatch('loadPrueba', {
				id: this.$route.params.id
			})
		},
	}
</script>
